import { render, staticRenderFns } from "./floornav.vue?vue&type=template&id=36bd8c22&scoped=true"
import script from "./floornav.vue?vue&type=script&lang=js"
export * from "./floornav.vue?vue&type=script&lang=js"
import style0 from "./floornav.vue?vue&type=style&index=0&id=36bd8c22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bd8c22",
  null
  
)

export default component.exports